module.exports = __webpack_public_path__ + "static/media/circle_mechanic_icon.5fb0b69b.svg";